/**
 * PortfoliYo Lab frontend bootstrap (IL-8.3).
 *
 * Mirrors `src/main.tsx` — same React root, same react-query configuration, same stylesheet — so
 * the shared pages behave identically under either entry. The only difference is which app it
 * mounts.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '../index.css';
import LabApp from './LabApp';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LabApp />
    </QueryClientProvider>
  </StrictMode>,
);
